<template>
    <ClModal
        v-model="showModal"
        maxWidth="500px"
    >
        <v-card>
            <v-card-title class="primary white--text">
                <h3>Notes</h3>
                <v-spacer/>
                <v-btn
                    icon
                    @click="closeModal()"
                >
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-textarea
                    ref="notesField"
                    v-model="localNotes"
                    label="Notes"
                    maxlength="250"
                    outlined
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <!-- Clear -->
                <ClButton
                    type="secondary"
                    :rounded="false"
                    @click="clearButtonHandler()"
                >
                    Clear
                </ClButton>
                <!-- Save -->
                <ClButton
                    :rounded="false"
                    @click="submitButtonHandler()"
                >
                    Save
                </ClButton>
            </v-card-actions>
        </v-card>
    </ClModal>
</template>

<script>
export default {
    name: 'ModalNotes',
    props: {
        notes: {
            type: String,
            required: false,
            default: '',
        },
        value: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            localNotes: this.notes,
        };
    },
    computed: {
        showModal: {
            get() {
                return this.value;
            },
            set( value ) {
                this.$emit( 'input', value );
            },
        },
    },
    watch: {
        showModal() {
            if ( this.showModal ) {
                this.localNotes = this.notes;
                this.$nextTick( () => {
                    this.focusInput();
                } );
            } else {
                this.clearButtonHandler();
            }
        },
    },
    methods: {
        focusInput() {
            this.$refs.notesField.focus();
        },
        closeModal() {
            this.showModal = false;
        },
        clearButtonHandler() {
            this.localNotes = '';
        },
        submitButtonHandler() {
            this.$emit( 'addNotes', this.localNotes );
            this.closeModal();
        },
    },
};
</script>

<style scoped lang="scss">
.v-dialog {
    >.v-card {
        >.v-card__text {
            margin-top: 2rem;
            padding-bottom: 0;
        }
        >.v-card__actions {
            padding-bottom: 1rem;
        }
    }
}
</style>
